import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export default class SessionExpiredService {
  private readonly isSessionExpiredSubject = new BehaviorSubject(false);
  public isSessionExpired$ = this.isSessionExpiredSubject.asObservable().pipe(distinctUntilChanged());
  private isSessionStarted = false;

  setSessionExpired() {
    if (this.isSessionStarted) this.isSessionExpiredSubject.next(true);
  }

  setSessionStarted() {
    this.isSessionStarted = true;
  }
}
